/**
 * Expose forEach
 */

module.exports = forEach['default'] = forEach

/**
 * forEach
 */

function forEach (fn, arr) {
  if (!arr) return

  for (var i = 0, len = arr.length; i < len; ++i) {
    fn.call(this, arr[i], i)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/@f/foreach-array/lib/index.js
// module id = ./node_modules/@f/foreach-array/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons